module.exports = __webpack_public_path__ + "media/images/lb/500-8742cfe3e769e1a7a01ca6991b5f2554.svg";